/*
 * @Author: changcheng
 * @LastEditTime: 2025-02-18 16:51:56
 */
export interface VideoProps {
  // 操作类型
  type: string;
  // 视频ID
  vid: string;
  // 站点ID
  siteid: string;
  // 是否允许拖拽进度条 1-允许 0-不允许
  progressbar_enable: number;
  // 视频观看位置(秒)
  videoWatchAt: number;
  // 项目ID
  projectId: number;
  // 课程ID
  courseId: string | number;
  // 视频唯一标识码
  videoUniqueCode:string;
  // 章节ID
  sectionId: string | number;
  // 视频类型
  videoType: string;
  // 防挂机标志 1-开启 0-关闭
  preventOnHookFlag: number;
  // 随机弹窗次数
  randomPopUpNum: number;
  // 防挂机提示信息
  onHookTipInfo: string;
  // 防止并发播放标志 1-开启 0-关闭
  preventConcurrentPlayFlag: number;
  // 话题ID
  topicId: string | number;
  // 学术活动ID
  saleActivityId?: string | number;
  // 更新视频列表的回调函数
  upDateVideoListFn: () => void;
}
const InitvideoStatus = {
  // 视频id
  vid: "",
  // ccUserId
  siteid: "",
  // 是否允许拖拽
  progressbar_enable: 1,
  // 观看位置
  videoWatchAt: 0,
  courseId: "",
  sectionId: "",
  forward:0, //左右方向键控制快进退步长
  videoType: "",
  videoUniqueCode:new Date().getTime()+'',
  preventOnHookFlag: 0,
  randomPopUpNum: 0,
  projectId: 0,
  onHookTipInfo: "辛苦，请继续观看！",
  preventConcurrentPlayFlag: 0,
  upDateVideoListFn: () => {},
  topicId: "",
  saleActivityId: "",
};
export const videoStatus = (state = InitvideoStatus, action: VideoProps) => {
  switch (action.type) {
    case "SET_VIDEO_STATUS":
      return {
        ...action,
      };
    default:
      return state;
  }
};
const InitUserInfo = {
  name: "",
  avatar: "",
  mobile:"",
};
export interface UserProps {
  // 操作类型
  type?: string;
  // 用户姓名
  name?: string;
  // 手机号码
  mobile?:string;
  // 用户头像
  avatar?: string;
}
export const userInfo = (state = InitUserInfo, action: UserProps) => {
  switch (action.type) {
    case "SET_USER_INFO":
      return {
        ...action,
      };
    default:
      return state;
  }
};
